import React, { useContext } from "react"
import { Formik } from "formik"
import {
  Alert,
  Button,
  TextInputField,
  Pane,
  Checkbox,
  Heading,
  Spinner,
  TickCircleIcon,
} from "evergreen-ui"
import { navigate } from "gatsby"
import DownloadAgreements from "./DownloadAgreements"
import { DealerContext } from "../../state/dealerProvider.js"
import { useTranslation } from "react-i18next"

const Basic = () => {
  const { i18n, t } = useTranslation()
  const labels = {
    confirmation: t("I accept to adhere to the agreement mentioned above"),
  }
  const context = useContext(DealerContext)
  const shops = {
    goodyear: context.data.dealerInfo && context.data.dealerInfo.goodyearShop,
    multibrand:
      context.data.dealerInfo && context.data.dealerInfo.multibrandShop,
    retail: context.data.dealerInfo && context.data.dealerInfo.retailShop,
  }

  if (context.data.loading) {
    return (
      <div>
        <Spinner data-testid="spinner" marginX="auto" marginY={120} />
      </div>
    )
  } else if (context.data.error !== "" || context.data.dealerInfo === null) {
    let message =
      t("Error fetching dealer information") +
      (context.data.error ? ": " + context.data.error : "")
    return (
      <div>
        <Alert intent="danger" title={message} />
      </div>
    )
  }
  return (
    <div>
      <DownloadAgreements shops={shops} />
      <Heading marginBottom="1rem">{t("Partner information")}</Heading>
      <Formik
        initialValues={{
          dealerName: context.data.dealerInfo.name,
          dealerPhoneNumber: context.data.dealerInfo.address.phone,
          dealerStreet: context.data.dealerInfo.address.street,
          dealerStreetNumber: context.data.dealerInfo.address.streetNumber,
          dealerPostalCode: context.data.dealerInfo.address.postalCode,
          dealerTown: context.data.dealerInfo.address.town,
          dealerRegistrationNumber: context.data.dealerInfo.registrationNumber,
          confirmation: context.data.confirmation,
        }}
        validate={(values, props) => {
          const errors = {}
          if (!values.confirmation) {
            errors.confirmation = t(
              "Please accept the agreement terms before continuing"
            )
          }
          return errors
        }}
        onSubmit={(values, { setSubmitting }) => {
          context.updateDealer(values)
          setSubmitting(false)
          navigate(`/${i18n.language}/shiptos`)
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            <Pane>
              <TextInputField
                label={t("Corporate name")}
                name="dealerName"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerName}
              />
            </Pane>
            <Pane display="flex">
              <TextInputField
                label={t("Street")}
                name="dealerStreet"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerStreet}
                width="75%"
                marginRight="1rem"
              />
              <TextInputField
                label={t("Street number")}
                name="dealerStreetNumber"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerStreetNumber}
                width="25%"
              />
            </Pane>
            <Pane display="flex">
              <TextInputField
                label={t("Postal code")}
                name="dealerPostalCode"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerPostalCode}
                width="25%"
                marginRight="1rem"
              />
              <TextInputField
                label={t("Town")}
                name="dealerTown"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerTown}
                width="75%"
              />
            </Pane>
            <Pane>
              <TextInputField
                label={t("Phone number")}
                name="dealerPhoneNumber"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerPhoneNumber}
              />
            </Pane>
            <Pane>
              <TextInputField
                label={t("Registration number")}
                name="dealerRegistrationNumber"
                required
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.dealerRegistrationNumber}
              />
            </Pane>
            <Pane>
              {errors.confirmation && touched.confirmation && (
                <Alert intent="warning" title={errors.confirmation} />
              )}
              <Checkbox
                required
                name="confirmation"
                label={labels.confirmation}
                onChange={handleChange}
                onBlur={handleBlur}
                checked={values.confirmation}
                marginBottom={24}
              />
            </Pane>
            <Pane
              display="flex"
              alignItems="center"
              justifyContent="center"
              borderTop="muted"
              padding="1rem"
            >
              <Button
                appearance="primary"
                intent="success"
                height={40}
                type="submit"
                iconBefore={TickCircleIcon}
                disabled={isSubmitting}
              >
                {t("Confirm & Continue")}
              </Button>
            </Pane>
          </form>
        )}
      </Formik>
    </div>
  )
}

export default Basic
